/**
 * ChildPicker — returning-family avatar picker.
 *
 * Shown when the session is 'family-only' (a family exists on this device
 * but no active child is selected). Tapping an avatar enters that child
 * and routes to the map.
 */

import { useState } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { enterAsUser, familyMembers } from '../state/user';
import { NavButton } from '../components/NavButton';

export function ChildPicker() {
  const { route } = useLocation();
  const [busy, setBusy] = useState(false);

  const members = familyMembers.value?.filter((m) => m.role === 'child') ?? [];

  async function pick(userId: string) {
    setBusy(true);
    try {
      await enterAsUser(userId);
      route('/map');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="flex-1 flex flex-col items-center justify-center px-6 py-10 gap-8 max-w-lg mx-auto w-full">
      <div class="text-center">
        <h1 class="text-4xl font-display text-coral">مَنْ هُنَا؟</h1>
        <p class="text-sm text-ink/60 mt-1" dir="ltr">
          Who is playing today?
        </p>
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 w-full">
        {members.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => pick(m.id)}
            disabled={busy}
            class="aspect-square rounded-3xl p-4 bg-white shadow-lg shadow-ink/10 active:scale-95 hover:scale-[1.02] transition-transform"
          >
            <img
              src={`/assets/avatars/${m.avatar ?? 1}.svg`}
              alt={m.name}
              class="w-full h-full rounded-2xl"
            />
            <span class="block text-base mt-2 font-display">{m.name}</span>
          </button>
        ))}
      </div>

      <NavButton
        ar="+ إِضَافَةُ طِفْلٍ"
        en="Add a child"
        onClick={() => route('/setup')}
      />
    </div>
  );
}
